import { BaseTableProps, TablePipeline } from 'ali-react-table';
import { featDict } from '..';
import { isEmpty } from 'lodash-es';

// 为每个表格扩展设置相应的选项
export const useSetupFeatures = (pipeline: { use: (arg0: (pipeline: TablePipeline) => TablePipeline) => void; }, featKey: React.PropsWithChildren<BaseTableProps| unknown>) => {
  const featureNames =[... Object.keys(featDict), 'customFeatKey'] as (keyof typeof featDict)[];
  if (isEmpty(featKey)) return; 
  // 多个表格拓展的应用顺序是固定的
  for (const featName of featureNames) {
    let opts: any = featKey[featName];
    if (!opts) {
      continue;
    }
    if (opts === true) {
      opts = {};
    }
    // 自定义use
    if (featName === ('customFeatKey' as string)) {
      Object.keys(opts).forEach((task) => {
        pipeline.use(opts[task]?.(pipeline));
      });
      return;
    }
    const feature = featDict[featName];
    pipeline.use(feature(opts));
  }
};